import { Button } from "components/buttons/button";
import { ValidatedInput } from "components/forms/input";
import { Layout } from "components/layout";
import { useInput } from "lib/hooks/use-input";
import { useUser } from "lib/hooks/use-user";

import Link from "next/link";
import { useState } from "react";

export const Signin = () => {
  const email = useInput("");
  const password = useInput("");
  const [resetSent, setResetSent] = useState(false);
  const [error, setError] = useState(false);
  const [isSubmitting, setSubmitting] = useState<boolean>(false);
  const {} = useUser(null, { redirectIfValid: "/" });

  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitting(true);
    let data = new URLSearchParams();
    data.append("email", email.value);
    data.append("password", password.value);

    fetch("api/auth/signin", {
      method: "POST",
      body: data,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.error) {
          setError(data.error.message);
          setSubmitting(false);
        } else {
          window.localStorage.setItem("jwt", data.jwt);
          location.assign(data.redirect);
        }
      })
      .catch((err) => {
        setError(true);
        setSubmitting(false);
      });
  };

  const handleForgottenPasswordSubmit = (event) => {
    event.preventDefault();
    setSubmitting(true);
    let data = new URLSearchParams();
    data.append("email", email.value);

    fetch("api/auth/forgotten-password", {
      method: "PUT",
      body: data,
    })
      .then((r) => r.json())
      .then((data) => {
        console.log(data);
        if (data.error) {
          setError(data.error.message);
          setSubmitting(false);
          setResetSent(false);
        } else {
          setResetSent(true);
          setSubmitting(false);
        }
      });
  };

  return (
    <>
      <Layout pageName='Signin'>
        <article className=' flex flex-col justify-center pt-12 pb-24 px-4 sm:px-6 lg:px-8'>
          <form
            className='mx-auto mb-24 bg-gray-100 p-8 space-y-4  w-full max-w-md'
            method='POST'
            onSubmit={handleSubmit}
            id='signinForm'>
            <fieldset>
              <legend className='font-header tracking-wide text-4xl'>
                Sign in
              </legend>

              <ValidatedInput
                type='email'
                id='email'
                bind={{ ...email.bind }}
                label='Email Address'
                inputProps={{ required: true, type: "email" }}
                showError={
                  (email.isModified && !emailRegex.test(email.value)) || error
                }
              />
              <ValidatedInput
                id='password'
                type='password'
                bind={{ ...password.bind }}
                label='Password'
                inputProps={{ required: true, type: "password" }}
                showError={error}
              />
            </fieldset>

            <section className='flex items-left justify-between flex-col space-y-2'>
              <div className='text-sm'>
                Don't have an account?{" "}
                <Link href='/signup'>
                  <a
                    href='#'
                    className='font-medium text-green-default hover:underline'>
                    Sign up
                  </a>
                </Link>
              </div>
            </section>
            {error && (
              <section className='bg-red-50 text-red-700 text-sm px-4 py-4 rounded-md'>
                {error}
              </section>
            )}
            <section>
              <button
                onClick={handleSubmit}
                disabled={!password.isModified || !emailRegex.test(email.value)}
                type='submit'
                className='w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium  bg-brand-yellow bg-yellow-default hover:bg-yellow-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-dark disabled:cursor-not-allowed disabled:bg-gray-200'>
                {isSubmitting ? "Signing in" : "Sign in"}
              </button>
            </section>
            <section className='pt-8 flex flex-col space-y-4'>
              <button
                onClick={handleForgottenPasswordSubmit}
                type='button'
                disabled={
                  !emailRegex.test(email.value) || isSubmitting || resetSent
                }
                className='text-sm border border-yellow-50 text-yellow-700 bg-yellow-50 rounded px-2 py-2 hover:border-yellow-dark hover:text-yellow-900 mx-auto disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-700'>
                {resetSent
                  ? "We've sent you a new password"
                  : "Help! I've forgotten my password"}
              </button>
              <p className='max-w-xs text-center mx-auto text-sm text-gray-700'>
                Clicking this button will send an email with a new random
                password to your email address
              </p>
            </section>
          </form>
        </article>
      </Layout>
    </>
  );
};

export default Signin;
